/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.package-header-container[_ngcontent-%COMP%]{display:flex;align-items:center}.package-header-container[_ngcontent-%COMP%]   .package-details-container[_ngcontent-%COMP%]{flex:1 1 auto}.package-header-container[_ngcontent-%COMP%]   .package-details-container[_ngcontent-%COMP%]   .package-detail[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{font-weight:700}.package-header-container[_ngcontent-%COMP%]   .download-package-container[_ngcontent-%COMP%]{flex:0 1 auto}.changelog[_ngcontent-%COMP%]{margin-top:20px}"];
export { styles as styles };
